import {
  Button,
  Col,
  Divider,
  Dropdown,
  Menu,
  Modal,
  PageHeader,
  Popconfirm,
  Popover,
  Row,
  Steps,
  Table,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ChevronDown } from "react-feather";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CardBody } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import {
  PoApprovalsApi,
  PoRevisionAPI,
  PoWoApi,
  PowoDeliveryChallanOpenApi,
  PowoPdfOpenApi,
} from "../../../../api";
import { fetchOrganisationDetails } from "../../../../api/organisation.api";
import { fetchPoPdfs, resendPoMail } from "../../../../api/po.api";
import handlePdfDownload from "../../../../utils/AwsFunctions/downloadFile";
import { poCreationAndEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import PoDetailsComponent from "./poDetailsComponent";
import TaxAmount from "./taxAmount";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const PODetailsPage = (props) => {
  const location = useLocation();
  const { po_id } = useParams();
  // const { details } = location.state;
  const [details, setPoDetails] = useState(null);
  const [track, setTrack] = useState([]);
  const [poApprovalStatus, setPoApprovalStatus] = useState("process");
  const [showRevisions, setShowRevisions] = useState(false);
  const [revisionDetails, setRevisionDetails] = useState({});
  const [approvePO, setApprovePO] = useState(false);
  const [approvePOId, setApprovePOId] = useState("");
  const [projectDetails, setProjectDetails] = useState(
    props?.settings?.project
  );
  const [organisationDetails, setOrganisationDetails] = useState(
    props?.settings?.organisation
  );

  const [revisionModalVisible, setRevisionModalVisible] = useState(false);
  const [currentStep, setCurrentStep] = useState([]);
  const [poRevisions, setPoRevisions] = useState([]);

  const getFormattedDate = (date) => {
    const formattedDate =
      // moment(date).format("ddd") +
      // " " +
      moment(date).format("MMM") +
      " " +
      moment(date).format("DD") +
      " " +
      moment(date).format("YYYY");

    return formattedDate;
  };
  const getOrderType = (type) => {
    if (type == "po") {
      return "PO";
    } else if (type == "wo") {
      return "WO";
    } else if (type == "internal") {
      return "Internal";
    } else if (type == "estimate") {
      return "Estimate";
    }
  };

  const fetchPoDetails = (id) => {
    axios.get(`${PoWoApi}${id}/`).then((res) => {
      setPoDetails(res.data);
    });
  };
  useEffect(() => {
    fetchPoPdfs({ po_id: po_id });
    fetchPoDetails(po_id);
  }, []);

  useEffect(() => {
    if (details) {
      var trackNew = [];
      var createdAt = moment(details?.created_at);
      const formattedDate =
        moment(createdAt).format("ddd") +
        " " +
        moment(createdAt).format("MMM") +
        " " +
        moment(createdAt).format("DD") +
        " " +
        moment(createdAt).format("YYYY");
      var firstStep = {
        step: "PO Raised",
        description: formattedDate,
      };
      trackNew.push(firstStep);
      var steps = details?.approval_flow;
      var stepsCompleted = 1;
      for (var i = 0; i < steps?.length; i++) {
        if (steps[i]?.is_approved) stepsCompleted += 1;
        var newStep = {
          step: steps[i]?.project_member__user_organisation__user__name,
          description: steps[i]?.is_approved ? "Approved" : "Approval Pending",
        };
        if (i == steps?.length - 1) {
          if (steps[i]?.is_approved) {
            setPoApprovalStatus("finish");
          }
        }
        if (steps[i]?.is_rejected) {
          newStep.description = "Rejected";
          setPoApprovalStatus("error");
        }
        if (
          steps[i]?.is_approved == false &&
          steps[i].is_rejected == false &&
          steps[i]?.project_member__user_organisation__user__id ==
            props.settings?.user?.id
        ) {
          if (i == 0) {
            setApprovePOId(steps[i]?.approval_id);
          } else if (steps[i - 1]?.is_approved == true) {
            setApprovePOId(steps[i]?.approval_id);
          }
          if (steps[i]?.approval_id && steps[i]?.approval_id > 0) {
            setApprovePO(true);
          }
        }
        if (steps[i]?.approval_id && steps[i]?.approval_id > 0) {
          trackNew.push(newStep);
        }
      }
      var finalStep = {
        step: "PO Status",
        description: !details?.is_approved ? "Pending" : "Approved",
      };
      trackNew.push(finalStep);
      if (details?.is_approved) {
        stepsCompleted = 1 + steps.length;
      }
      setCurrentStep(stepsCompleted);
      setTrack(trackNew);
      fetchPoRevisions({ po_number: details?.po_number });
    }
  }, [details]);

  useEffect(() => {
    console.log("organisationDetails", organisationDetails);
  }, [organisationDetails]);
  const setOrganisationData = () => {
    fetchOrganisationDetails().then((res) => {
      setOrganisationDetails(res);
    });
  };
  useEffect(() => {
    if (props?.settings?.organisation?.id) {
    } else {
      setOrganisationData();
    }
  }, [props?.settings?.organisation]);

  useEffect(() => {
    setProjectDetails(props?.settings?.project);
  }, [props?.settings?.project]);
  const fetchPoRevisions = ({ po_number }) => {
    axios.get(`${PoRevisionAPI}?po_number=${po_number}`).then((res) => {
      setPoRevisions(res?.data);
    });
  };
  const { Step } = Steps;
  const history = useNavigate();
  const columns = [
    {
      title: "BOQ Item",
      key: "boq_item",
      render: (data) => (
        <span>
          {data?.sub_item ? data?.sub_item?.boq_sub_item : data?.item?.boq_item}
        </span>
      ),
    },
    {
      title: "Description",
      key: "item_description",
      ellipsis: {
        showTitle: false,
      },
      render: (data) => (
        <Popover
          placement="topLeft"
          title={"Item Description"}
          content={
            data?.sub_item
              ? data?.sub_item?.item_description
              : data?.item?.item_description
          }
        >
          {data?.sub_item
            ? data?.sub_item?.item_description
            : data?.item?.item_description}
        </Popover>
      ),
      width: 200,
    },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
    },
    {
      title: "Unit",
      key: "unit",
      render: (data) => (
        <span>{data?.sub_item ? data?.sub_item?.unit : data?.item?.unit}</span>
      ),
    },
    {
      title: "Make/Brand",
      key: "brand",
      render: (data) => (
        <span>
          {data?.sub_item ? data?.sub_item?.brand : data?.item?.brand}
        </span>
      ),
    },
    {
      title: "Price",
      key: "unit_po_price",
      render: (data) => (
        <>
          <div>₹{data?.unit_po_price}</div>
          <div>
            Budget : ₹
            {data?.sub_item
              ? data?.sub_item?.budget_price
              : data?.item?.budget_price}
          </div>
        </>
      ),
    },
    {
      title: "Discount",
      key: "discount",
      render: (data) => <>{parseFloat(data?.discount ?? 0)?.toFixed(2)}</>,
    },
    {
      title: "Tax Value",
      key: "tax_value",
      dataIndex: "tax_value",
    },
    {
      title: "Tax type",
      key: "tax_type",
      // dataIndex: "tax_type",
      render: (data) => (
        <>
          {data?.tax_type == "igst" && "IGST"}
          {data?.tax_type == "cgst_sgst" && "CGST & SGST"}
          {data?.tax_type == "none" && "None"}
        </>
      ),
    },
    {
      title: "Amount",
      key: "amount",
      render: (data) => {
        var total = Number(data?.quantity) * Number(data?.unit_po_price ?? 0);
        var discount = data?.discount;
        var price = total - total * discount * 0.01;
        var tax = data?.tax_value;
        price += price * 0.01 * tax;
        return <span>₹ {(data.total ? data.total : price)?.toFixed(2)}</span>;
      },
    },
    {
      title: "Actions",
      key: "action",
      render: (data) => {
        return (
          <Button
            onClick={() => {
              history("/app/project/budget", {
                state: {
                  item_id: data?.item?.id,
                },
              });
            }}
          >
            Go to Item
          </Button>
        );
      },
    },
  ];

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const getTotalTaxableAmount = () => {
    let amount = 0;
    details?.po_items?.map((item) => {
      amount +=
        item.quantity * item.unit_po_price -
        item.quantity * item.unit_po_price * 0.01 * item.discount;
      console.log("amount taxable", item, amount);
    });
    return amount;
  };

  const onDelete = (id) => {
    const formData = new FormData();
    formData.append("is_deleted", true);
    axios
      .put(`${PoWoApi}${id}/`, formData)
      .then((res) => {
        toast.success("Successfully cancelled PO!");
        window.history.back();
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };
  const getRevisionDetails = ({ po_id }) => {
    axios.get(`${PoWoApi}${po_id}`).then((res) => {
      setRevisionDetails(res?.data);
    });
  };

  const onApprove = () => {
    const formData = new FormData();
    formData.append("is_approved", true);
    axios
      .put(`${PoApprovalsApi}${approvePOId}/`, formData)
      .then((res) => {
        toast.success("PO Approved Successfully!");
        history(-1);
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };

  return (
    <React.Fragment>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="PO Details"
        extra={[
          <>
            {poRevisions?.length > 0 && (
              <Button
                onClick={() => {
                  setShowRevisions(!showRevisions);
                }}
              >
                See Revisions
              </Button>
            )}
          </>,
          <>
            {poCreationAndEditGranted(props.settings?.user) && (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key="1"
                      onClick={() => {
                        history(`/app/project/powo/edit/` + details?.id, {
                          state: { editId: details?.id },
                        });
                      }}
                    >
                      Edit Po
                    </Menu.Item>
                    {approvePO && (
                      <Menu.Item key="2">
                        <Popconfirm
                          onConfirm={() => onApprove()}
                          okText={"Yes"}
                          cancelText={"No"}
                          title={"Do you want to approve?"}
                        >
                          Approve Po
                        </Popconfirm>
                      </Menu.Item>
                    )}
                    {/* <Menu.Item
                  key="2"
                  onClick={() => {
                    generatePdf(
                      details,
                      taxOptions,
                      organisationDetails?.organisation_logo
                    );
                  }}
                >
                  Save as pdf
                </Menu.Item> */}
                    <Menu.Item
                      key="6"
                      onClick={() => {
                        window.open(
                          PowoDeliveryChallanOpenApi + details?.id,
                          "_blank"
                        );
                      }}
                    >
                      Download delivery challan
                    </Menu.Item>
                    <Menu.Item
                      key="4"
                      onClick={() => {
                        window.open(PowoPdfOpenApi + details?.id, "_blank");
                      }}
                    >
                      Download pdf
                    </Menu.Item>
                    {details?.is_approved && (
                      <Menu.Item
                        key="5"
                        onClick={() => {
                          resendPoMail({
                            po_id: details?.id,
                          });
                        }}
                      >
                        Resend Po mail
                      </Menu.Item>
                    )}

                    <Popconfirm
                      title="Are you sure to cancel PO?"
                      onConfirm={() => onDelete(details?.id)}
                    >
                      <Menu.Item key="3">Cancel Po</Menu.Item>
                    </Popconfirm>
                  </Menu>
                }
                key="1"
                className=""
              >
                <Button className="btn btn-primary text-white d-flex justify-content-center align-items-center">
                  PO Actions <ChevronDown />
                </Button>
                {/* PO Actions */}
              </Dropdown>
            )}
          </>,
        ]}
      ></PageHeader>
      {showRevisions && (
        <PageHeader ghost={false} className="mt-3">
          <Row gutter={16}>
            {poRevisions?.map((revision, index) => {
              return (
                <Col
                  sm={6}
                  className="d-flex justify-content-center border p-2"
                >
                  <Col>
                    <Col>Created by: {revision?.revised_by__name}</Col>
                    <Col>
                      Created at: {getFormattedDate(revision?.modified_at)}
                    </Col>
                    <Col
                      style={{ width: "100%" }}
                      className="d-flex justify-content-space-between mt-1"
                    >
                      <Button
                        onClick={() => {
                          getRevisionDetails({ po_id: revision?.id });
                          setRevisionModalVisible(true);
                        }}
                      >
                        See PO: {index + 1}
                      </Button>
                      <Button
                        onClick={() => {
                          window.open(PowoPdfOpenApi + revision?.id, "_blank");
                        }}
                      >
                        See pdf
                      </Button>
                    </Col>
                  </Col>
                </Col>
              );
            })}
          </Row>
        </PageHeader>
      )}

      {details?.is_deleted ? null : (
        <PageHeader subTitle="Po Status" className="mt-3" ghost={false}>
          <div className="px-2">
            <Steps
              direction="horizontal"
              size="small"
              current={currentStep}
              status={poApprovalStatus}
            >
              {track?.map((each, index) => (
                <Step
                  key={index}
                  title={each?.step}
                  description={each?.description}
                />
              ))}
            </Steps>
          </div>
        </PageHeader>
      )}
      <Divider orientation="horizontal" />

      <Col style={{ background: "#fff" }}>
        <CardBody>
          <Row gutter={24}>
            <Col sm={12}>
              <img
                src={organisationDetails?.organisation_logo}
                style={{ height: 120 }}
              />
            </Col>
            <Col sm={12}>
              <Row gutter={16} className="mt-3">
                <Col sm={5} md={5}>
                  PO Number
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={22}>{details?.po_number}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16} className="mt-3">
                <Col sm={5} md={5}>
                  Created By
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={22}>{details?.created_by}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16} className="mt-3">
                <Col sm={5} md={5}>
                  Type of Order
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{getOrderType(details?.type_of_order)}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16} className="mt-3">
                <Col sm={5} md={5}>
                  Delivery / Handover Date
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.delivery_date}</Col>
                  </Row>
                </Col>
              </Row>
              {props.settings?.organisation?.lead_field && (
                <Row gutter={16} className="mt-3">
                  <Col sm={5} md={5}>
                    Lead ID
                  </Col>
                  <Col sm={19} md={19}>
                    <Row>
                      <Col sm={1}>:</Col>
                      <Col sm={11}>#{details?.lead_id}</Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </CardBody>
        <Divider orientation="horizontal" />
        <Row gutter={24} className="mt-3">
          <Col sm={11}>
            <CardBody>
              <div className="">
                <H6>Bill To</H6>
              </div>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Name
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{organisationDetails?.name}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Address
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>
                      {details?.gst?.address}
                      {/* {props?.settings?.branch?.address} */}
                    </Col>
                  </Row>
                </Col>
              </Row>
              {/* <Row gutter={16} >
                      <Col sm={5} md={5}>
                        PIN Code
                      </Col>
                      <Col sm={19} md={19}>
                        <Row>
                          <Col sm={1}>:</Col>
                          <Col sm={11}></Col>
                        </Row>
                      </Col>
                    </Row> */}
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  GST
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.gst?.gst_no}</Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Col>
          <Col>
            <Divider type="vertical" style={{ height: "100%" }} />
          </Col>
          <Col sm={11}>
            <CardBody>
              <div className="">
                <H6>Vendor Details</H6>
              </div>
              <Row gutter={24} className="">
                <Col sm={7} md={7}>
                  Vendor Name
                </Col>
                <Col sm={17} md={17}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.vendor?.name}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={24} className="">
                <Col sm={7} md={7}>
                  Address
                </Col>
                <Col sm={17} md={17}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={23}>{details?.vendor?.billing_address}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={24} className="">
                <Col sm={7} md={7}>
                  Vendor Code
                </Col>
                <Col sm={17} md={17}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={23}>{details?.vendor?.vendor_code}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={24} className="">
                <Col sm={7} md={7}>
                  Contact Details
                </Col>
                <Col sm={17} md={17}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={23}>
                      {details?.vendor?.contact}, {details?.vendor?.email}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={24} className="">
                <Col sm={7} md={7}>
                  GST
                </Col>
                <Col sm={17} md={17}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={23}>{details?.vendor?.gst}</Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Col>
        </Row>
        <Divider orientation="horizontal" />
        <CardBody>
          <H6>Ship To</H6>
          <Row gutter={24} className="mt-3">
            <Col sm={12}>
              <Row gutter={16}>
                <Col sm={4} md={4}>
                  Name
                </Col>
                <Col sm={20} md={20}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{projectDetails?.project_name}</Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={24} className="mt-3">
            <Col sm={12}>
              <Row gutter={24} className="mt-3">
                <Col sm={12}>
                  <Row gutter={16}>
                    <Col sm={4} md={4}>
                      Address
                    </Col>
                    <Col sm={20} md={20}>
                      <Row>
                        <Col sm={1}>:</Col>
                        <Col sm={23}>
                          {details?.address_description ?? (
                            <>
                              {details?.address?.address},{" "}
                              {details?.address?.city}-
                              {details?.address?.pincode}
                            </>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={6}>Pincode</Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.address?.pincode}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16} className="mt-2">
                <Col sm={6}>Contact person</Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.address?.contact_person}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={6}>Contact number</Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.address?.contact_phone}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16} className="mt-1">
                <Col sm={6}>Selected address: </Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>
                      {details?.address?.address}, {details?.address?.city}{" "}
                      {details?.address?.pincode}
                    </Col>
                  </Row>
                </Col>
              </Row>
              {details?.address?.google_map_address && (
                <Row gutter={16} className="mt-1">
                  <Col sm={6}>Google Map Address</Col>
                  <Col sm={18}>
                    <Row>
                      <Col sm={1}>:</Col>
                      <Col sm={11}>
                        <a
                          href={details?.address?.google_map_address}
                          target="_blank"
                        >
                          {
                            details?.address?.google_map_address?.length > 50
                              ? details?.address?.google_map_address?.substring(0, 50) + "..."
                              : details?.address?.google_map_address
                          }
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </CardBody>
        <Divider orientation="horizontal" />
        <CardBody>
          <Table
            dataSource={details?.po_items}
            columns={columns}
            scroll={{ x: "100%" }}
          />
        </CardBody>
        <Divider orientation="horizontal" />

        <Row>
          <Col sm={11}>
            <CardBody>
              <H6>Payment Terms</H6>
              <CardBody>
                {details?.po_payment_terms?.map((each, ind) => {
                  return (
                    <>
                      {each?.percentage > 0 && (
                        <div key={ind}>
                          {each?.term}:{each?.percentage}%
                        </div>
                      )}
                    </>
                  );
                })}
              </CardBody>
            </CardBody>
            <Divider orientation="horizontal" />
            <CardBody>
              <H6>Terms and Conditions</H6>
              <CardBody>
                <div className="mb-2">
                  {details?.terms_and_condition?.description}
                </div>
              </CardBody>
            </CardBody>
            <CardBody>
              <div className="">
                <div>
                  <span style={{ fontSize: "18px", fontWeight: "bolder" }}>
                    Documents
                  </span>{" "}
                  {"(Total files size should be less than 25MB)"}
                </div>
                {details?.documents?.map((document, index) => {
                  return (
                    <Col style={{ padding: 8 }}>
                      <Col
                        style={{
                          border: "1px #D1D0CE solid",
                          padding: 4,
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          openInNewTab(document?.file);
                        }}
                      >
                        {document?.file_name ??
                          document?.file?.replace(
                            "https://mysite-powo-pdfs.s3.ap-south-1.amazonaws.com/media/porject_files/",
                            ""
                          )}
                      </Col>
                    </Col>
                  );
                })}
                {details?.old_attachment !== "" &&
                  JSON.parse(details?.old_attachment ?? "[]")?.map(
                    (document) => {
                      return (
                        <Col style={{ padding: 8 }}>
                          <Col
                            style={{
                              border: "1px #D1D0CE solid",
                              padding: 4,
                              cursor: "pointer",
                              fontWeight: 500,
                            }}
                            onClick={() => {
                              const extension = document.split(".").pop();
                              handlePdfDownload(
                                document.replace(`.${extension}`, ""),
                                extension
                              );
                              // openInNewTab(
                              //   "https://mysite-powo-pdfs.s3.ap-south-1.amazonaws.com/" +
                              //     document
                              // );
                            }}
                          >
                            {document ?? ""}
                          </Col>
                        </Col>
                      );
                    }
                  )}
              </div>
            </CardBody>
          </Col>
          <Col>
            <Divider type="vertical" style={{ height: "100%" }} />
          </Col>
          <Col sm={12}>
            <CardBody>
              <div className="d-flex justify-content-between">
                <div className="">Taxable Amount</div>
                <div className="">
                  {Number(getTotalTaxableAmount()).toFixed(2)}
                </div>
              </div>
              <TaxAmount items={details?.po_items} />
            </CardBody>
            <Divider orientation="horizontal" />
            <CardBody>
              {details?.po_additional_charges?.map((each, ind) => (
                <div className="d-flex justify-content-between" key={ind}>
                  <div className="">
                    {each?.charge_type + " ("}
                    {each?.tax_type == "igst"
                      ? `${each?.tax_value}% ${
                          each?.tax_type == "igst" ? "IGST" : ""
                        }`
                      : ""}

                    {each?.tax_type == "cgst_sgst"
                      ? `${each?.tax_value / 2}% CGST & `
                      : ""}
                    {each?.tax_type == "cgst_sgst"
                      ? `${each?.tax_value / 2}% SGST`
                      : ""}
                    {each?.tax_type == "None" ? `${each?.tax_value}` + "%" : ""}
                    {")"}
                  </div>
                  <div className="">
                    {(
                      Number(each?.amount) +
                      Number(each?.amount) * Number(each?.tax_value) * 0.01
                    ).toFixed(2)}
                  </div>
                </div>
              ))}
            </CardBody>
            <Divider orientation="horizontal" />
            <CardBody>
              <div className="d-flex justify-content-between">
                <div className="">
                  <H6>Total Amount</H6>
                </div>
                <div className="">
                  {Number(details?.total_po_raised_amount).toFixed(2)}
                </div>
              </div>
            </CardBody>
          </Col>
        </Row>
        <Divider orientation="horizontal" />
      </Col>

      <Modal
        width={"80%"}
        visible={revisionModalVisible}
        onCancel={() => {
          setRevisionModalVisible(false);
        }}
        onOk={() => {
          setRevisionModalVisible(false);
        }}
        bodyStyle={{
          padding: 16,
        }}
      >
        <PoDetailsComponent
          details={revisionDetails}
          organisationDetails={organisationDetails}
          projectDetails={projectDetails}
        />
      </Modal>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(PODetailsPage);
